module.exports = __webpack_public_path__ + "static/media/bowtie-co-sq-white.36ac3f38.png";